import React from 'react';
import { Form, Select, Checkbox, Divider } from 'antd';

const { Option } = Select;

const SelectBackupAdminUser = ({ users }) => (
  <>
    <Form.Item
      name={['backupAdmin', 'user']}
      label="Backup Admin User"
      rules={[{ required: true, message: 'Please select a Backup Admin User!' }]}
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
    >
      <Select style={{ width: '400px' }} placeholder="Select a Backup Admin User">
        {users.map((user) => (
          <Option key={user.id} value={user.id}>
            {user.name}
          </Option>
        ))}
      </Select>
    </Form.Item>

    <Divider />

    <Form.Item
      name={['backupAdmin', 'send_email']}
      valuePropName="checked"
      wrapperCol={{ offset: 8, span: 16 }}
    >
      <Checkbox>Send Email to Backup Admin</Checkbox>
    </Form.Item>

    <Form.Item
      name={['backupAdmin', 'send_notification']}
      valuePropName="checked"
      wrapperCol={{ offset: 8, span: 16 }}
    >
      <Checkbox>Send In-App Notification to Backup Admin</Checkbox>
    </Form.Item>
  </>
);

export default SelectBackupAdminUser;
